import { cn } from '~/lib/utils'

interface EmailPreviewFrameProps {
  html: string
  className?: string
}

export function EmailPreviewFrame({ html, className }: EmailPreviewFrameProps) {
  return (
    <iframe
      title="email-preview"
      srcDoc={html}
      className={cn('min-h-[760px] w-full rounded-[32px] bg-white', className)}
      sandbox="allow-same-origin"
      referrerPolicy="no-referrer"
    />
  )
}
